import React, { useEffect, useState } from 'react'

import SEO from 'components/SEO/SEO'
import Preloader from 'components/Preloader/Preloader'
import Button from 'components/Forms/Button/Button'
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog'

import {
    GET_COUNTRIES_CURRENCY,
    CREATE_COUNTRY_CURRENCY,
    UPDATE_COUNTRY_CURRENCY,
    DELETE_COUNTRY_CURRENCY,
    GET_CURRENCIES,
    CREATE_CURRENCY,
    EDIT_CURRENCY,
} from 'api/products'

import useModal from 'hooks/useModal'

import CountryTable from './components/CountryTable/CountryTable'
import CurrenciesList from './components/CurrenciesList/CurrenciesList'
import EditCountryCurrencyModal from './components/EditCountryCurrencyModal/EditCountryCurrencyModal'
import AddCountryCurrencyModal from './components/AddCountryCurrencyModal/AddCountryCurrencyModal'
import EditCurrencyModal from './components/EditCurrencyModal/EditCurrencyModal'
import AddCurrencyModal from './components/AddCurrencyModal/AddCurrencyModal'

import { MODALS } from './constants'

import styles from './Currencies.module.scss'

const Currencies = () => {
    const [isReady, setIsReady] = useState(false)

    const [isLoadingCurrencies, setIsLoadingCurrencies] = useState(false)
    const [currencies, setCurrencies] = useState([])

    const [isLoadingCountriesCurrency, setIsLoadingCountriesCurrency] = useState(false)
    const [countriesCurrency, setCountriesCurrency] = useState([])

    const { modalName, modalPayload, onOpenModal, onCloseModal } = useModal()

    useEffect(() => {
        Promise.all([refreshCountriesCurrency(), refreshCurrencies()])
            .then(() => setIsReady(true))
            .catch(err => console.error(err))
    }, [])

    const refreshCountriesCurrency = async () => {
        try {
            setIsLoadingCountriesCurrency(true)
            const data = await GET_COUNTRIES_CURRENCY()
            setCountriesCurrency(data)
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoadingCountriesCurrency(false)
        }
    }
    const refreshCurrencies = async () => {
        try {
            setIsLoadingCurrencies(true)
            const data = await GET_CURRENCIES()
            setCurrencies(data)
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoadingCurrencies(false)
        }
    }

    const onUpdateCountryCurrency = async data => {
        try {
            await UPDATE_COUNTRY_CURRENCY(data.id, data)
            await refreshCountriesCurrency()
        } catch (err) {
            console.error(err)
        }
    }
    const onAddCountryCurrency = async data => {
        try {
            await CREATE_COUNTRY_CURRENCY(data)
            await refreshCountriesCurrency()
        } catch (err) {
            console.error(err)
        }
    }
    const onDeleteCountryCurrency = async data => {
        try {
            await DELETE_COUNTRY_CURRENCY(data.id)
            await refreshCountriesCurrency()
        } catch (err) {
            console.error(err)
        }
    }
    const onEditCurrency = async data => {
        try {
            await EDIT_CURRENCY(data.id, data)
            await Promise.all([refreshCurrencies(), refreshCountriesCurrency()])
        } catch (err) {
            console.error(err)
        }
    }
    const onAddCurrency = async data => {
        try {
            await CREATE_CURRENCY(data)
            await refreshCurrencies()
        } catch (err) {
            console.error(err)
        }
    }

    return (
        <div className={styles.plans}>
            <SEO title="Currencies" />

            {isReady ? (
                <>
                    <CurrenciesList isLoading={isLoadingCurrencies} currencies={currencies} onOpenModal={onOpenModal} />
                    <br />
                    <br />
                    <div className={styles.buttonBox}>
                        <Button
                            content="+ Add new country"
                            variant="primary"
                            onClick={() => onOpenModal(MODALS.ADD_COUNTRY_CURRENCY)}
                        />
                    </div>
                    <CountryTable
                        title="Countries currency"
                        list={countriesCurrency}
                        methods={{
                            onOpenModal,
                        }}
                        isLoading={isLoadingCountriesCurrency}
                    />
                </>
            ) : (
                <Preloader />
            )}

            {modalName === MODALS.EDIT_COUNTRY_CURRENCY && (
                <EditCountryCurrencyModal
                    currencies={currencies}
                    otherCountryCodes={countriesCurrency
                        .filter(item => item.countryCode !== modalPayload.countryCode)
                        .map(item => item.countryCode)}
                    payload={modalPayload}
                    onClose={onCloseModal}
                    onSubmit={onUpdateCountryCurrency}
                />
            )}
            {modalName === MODALS.ADD_COUNTRY_CURRENCY && (
                <AddCountryCurrencyModal
                    currencies={currencies}
                    countryCodes={countriesCurrency.map(item => item.countryCode)}
                    onClose={onCloseModal}
                    onSubmit={onAddCountryCurrency}
                />
            )}
            {modalName === MODALS.EDIT_CURRENCY && (
                <EditCurrencyModal
                    otherCurrencyCodes={currencies
                        .filter(item => item.currency !== modalPayload.currency)
                        .map(item => item.currency)}
                    payload={modalPayload}
                    onClose={onCloseModal}
                    onSubmit={onEditCurrency}
                />
            )}
            {modalName === MODALS.ADD_CURRENCY && (
                <AddCurrencyModal
                    currencyCodes={currencies.map(item => item.currency)}
                    onClose={onCloseModal}
                    onSubmit={onAddCurrency}
                />
            )}
            {modalName === MODALS.DELETE_COUNTRY_CURRENCY && (
                <ConfirmationDialog
                    onClose={onCloseModal}
                    onAction={async () => onDeleteCountryCurrency(modalPayload)}
                    targetText={`Country: ${modalPayload.countryCode} | Currency: ${modalPayload.currency} (${modalPayload.symbol})`}
                    successText="Country currency removed successfully!"
                    headText="Please, confirm"
                    noteText={`Are you sure you want to remove country currency?`}
                    actionVariant="danger"
                    actionText="Remove"
                    cancelText="Cancel"
                />
            )}
        </div>
    )
}

export default Currencies
